import React, { useEffect, useMemo, useRef, useState } from 'react'
import { LoadingContent } from '../../../components/LoadingContent';
import { Pagination } from '../../../components/Pagination';
import { Calendar } from '../../../components/svg/Calendar';
import { Cruz } from '../../../components/svg/Cruz';
import { Filter } from '../../../components/svg/Filter';
import { Star } from '../../../components/svg/Star';
import { Table } from '../../../components/Table';
import { serviciosService } from '../../../services/servicios';
import { ABMServiciosModal } from './ABMServiciosModal';
import { serviciosColumns } from './serviciosColumns';
import { ServiciosForm } from './ServiciosForm';

export const ServiciosPanel = () => {

    const filtrosDefault = {
        nombre: "",
        precio_min: "",
        precio_max: "",
        principal: "TODOS",
        vigente: true,
    }

    const [inputsForm, setInputsForm] = useState(filtrosDefault);

    const [isloading, setIsLoading] = useState();

    const [page, setPage] = useState();
    const [cantidad, setCantidad] = useState();
    const [servicios, setServicios] = useState();

    const [showFilters, setShowFilters] = useState(false);

    const isMountedSignalRef = useRef();

    const searchServicios = async (filtros = {}) => {
        if (filtros.principal == "TODOS") delete filtros.principal
        if (filtros.vigente == "TODOS") delete filtros.vigente
        if (filtros.oculto == "TODOS") delete filtros.oculto

        try {
            setIsLoading(true);
            const response = await serviciosService.getServicios(filtros, isMountedSignalRef.current)
            setCantidad(response.cantidad)
            setServicios(response.elementos)
            setPage(response.page)
        }
        catch (err) {
            console.log(err)
        }
        finally {
            setIsLoading(false)
        }
    }

    const columns = useMemo(() => serviciosColumns(searchServicios), [inputsForm])


    const loadPanel = async () => {
        setPage(1)
        await searchServicios(inputsForm);
    }

    useEffect(() => {
        const abortController = new AbortController();
        isMountedSignalRef.current = abortController.signal;
        loadPanel();
        return () => abortController.abort();
    }, [])

    return (
        <div className="admin-panel admin__panel-container">
            <div className="admin-panel__title-container">
                <h1 className="section-title mb-3" style={{ textAlign: "center" }}>Panel de Servicios</h1>
                <ABMServiciosModal createAction recargarLista={searchServicios} />
                <button
                    className="btn-icon navBar-button btn-back-white admin-panel__btn-filters"
                    style={{ padding: "6px", position: "absolute", right: "50px" }}
                    onClick={() => { setShowFilters(st => !st) }}
                >
                    { }
                    <Filter size={"2rem"} style={{ pointerEvent: "none" }} />
                </button>
            </div>

            <ServiciosForm
                searchFunction={searchServicios}
                hideComponent={!showFilters}
                isloading={isloading}
                inputsForm={inputsForm}
                setInputsForm={setInputsForm}
            />

            {!isloading && <div style={{ marginTop: "30px" }}>
                {cantidad > 0 &&
                    <>
                        <Table
                            onSelect={() => { }}
                            hideHeadRow={false}
                            key={{}}
                            tableMin={true}
                            className="admin-table initialOpacity entranceOpacity"
                            style={{ animationDelay: "0ms" }}
                            columns={columns}
                            data={servicios}
                            tableName="admin-servicios"
                        />
                        <Pagination
                            filters={inputsForm}
                            changePage={searchServicios}
                            cantidad={cantidad}
                            setPage={setPage}
                            page={page}
                            tableName="admin-servicios"
                        />
                    </>
                }

                {cantidad == 0 && <p>
                    No hay servicios que coincidan con la busqueda realizada
                </p>}

            </div>
            }

            {isloading && <LoadingContent></LoadingContent>}

        </div>
    )
}
